import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Box, Button, Checkbox, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import BDrawer from '@ui/components/common/BDrawer';
const PassportNonDisclosureDialog = ({ open, onClose, onContinue }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [accepted, setAccepted] = useState(false);
    const nonDisclosureTitle = useMemo(() => t('events.eventDetails.passportTab.termsAndConditionsTitle'), [t]);
    const handleClose = () => {
        setAccepted(false);
        onClose();
    };
    const handleContinue = () => {
        if (!accepted)
            return;
        setAccepted(false);
        onContinue();
    };
    const p = 'events.eventDetails.passportTab.nda';
    const ndaSections = useMemo(() => [
        {
            heading: t(`${p}.titleHeading`),
            subheading: t(`${p}.titleSubheading`),
            body: null
        },
        { heading: t(`${p}.recitalsHeading`), body: t(`${p}.recitalsBody`) },
        { heading: t(`${p}.definitionHeading`), body: t(`${p}.definitionBody`) },
        { heading: t(`${p}.purposeHeading`), body: t(`${p}.purposeBody`) },
        { heading: t(`${p}.obligationsHeading`), body: t(`${p}.obligationsBody`) },
        { heading: t(`${p}.auditHeading`), body: t(`${p}.auditBody`) },
        { heading: t(`${p}.prohibitedHeading`), body: t(`${p}.prohibitedBody`) },
        { heading: t(`${p}.durationHeading`), body: t(`${p}.durationBody`) },
        { heading: t(`${p}.breachHeading`), body: t(`${p}.breachBody`) },
        { heading: t(`${p}.dataProtectionHeading`), body: t(`${p}.dataProtectionBody`) },
        {
            heading: t(`${p}.electronicConsentHeading`),
            body: t(`${p}.electronicConsentBody`)
        }
    ], [t]);
    const textContent = (_jsx(Box, { sx: {
            width: '100%',
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            overflow: 'hidden'
        }, children: _jsx(Box, { sx: {
                maxHeight: 320,
                overflowY: 'auto',
                p: 2.5,
                bgcolor: theme.palette.grey[50]
            }, children: ndaSections.map((section, i) => (_jsxs(Box, { mb: 2.5, children: [_jsx(Typography, { variant: 'subtitle2', fontWeight: 700, sx: { textTransform: 'uppercase', letterSpacing: 0.5, mb: 0.5 }, children: section.heading }), section.subheading && (_jsx(Typography, { variant: 'body2', color: 'text.secondary', sx: { mb: 0.5 }, children: section.subheading })), section.body &&
                        section.body.split('\n\n').map((para, j) => (_jsx(Typography, { variant: 'body2', color: 'text.primary', sx: { mb: 1 }, children: para }, j)))] }, i))) }) }));
    const consentRow = (_jsxs(Box, { display: 'flex', alignItems: 'flex-start', gap: 1.25, children: [_jsx(Checkbox, { checked: accepted, onChange: (e) => setAccepted(e.target.checked), sx: { mt: 0.2 } }), _jsx(Typography, { variant: 'body2', color: 'text.primary', sx: { lineHeight: 1.5 }, children: t('events.eventDetails.passportTab.nonDisclosureConsentText') })] }));
    const body = (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 2, p: 1, children: [textContent, consentRow] }));
    const actions = (_jsxs(_Fragment, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', size: 'large', onClick: handleClose, fullWidth: true, children: t('actions.cancel') }), _jsx(Button, { variant: 'contained', color: 'inherit', size: 'large', onClick: handleContinue, disabled: !accepted, fullWidth: true, children: t('events.eventDetails.passportTab.continue') })] }));
    if (isSmallScreen) {
        return (_jsx(BDrawer, { open: open, onClose: handleClose, title: nonDisclosureTitle, anchor: 'bottom', showBottomBar: true, dialogActions: actions, slotProps: {
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(25px)',
                        WebkitBackdropFilter: 'blur(25px)'
                    }
                }
            }, children: _jsx(Box, { sx: { p: 2 }, children: body }) }));
    }
    return (_jsx(CustomDialog, { open: open, onClose: handleClose, titleWithIcon: nonDisclosureTitle, titleIcon: '/assets/images/document-agreement.png', maxWidth: 'md', backgroundVariant: 'white', backdropBlur: 25, closeIcon: true, actions: actions, children: _jsx(Box, { p: 1.5, children: body }) }));
};
export default PassportNonDisclosureDialog;
